import { getSalesReport } from './getSalesReport'
import { setPeritajeStatusAddedCars } from './setPeritajeStatusAddedCars'
import { setPeritajeStatusRemovedCars } from './setPeritajeStatusRemovedCars'

export const GestionOperativa = {
    getSalesReport,
    setPeritajeStatusAddedCars,
    setPeritajeStatusRemovedCars
};
